import React, { useState, useEffect, useRef } from 'react'

const Report = () => {
	const mediaWeb = window.matchMedia("(min-width:600px)").matches
	const iframeRef = useRef(null);
	let width = window.innerWidth * (98.5 / 100);
	let tempHeight = window.innerHeight;
	let headerHeight = (9 / 100) * tempHeight;
	let height = tempHeight - headerHeight

	if (localStorage.tipo == "coordenacao" || localStorage.tipo == "presidencia" ||
		localStorage.tipo == "vice-presidencia" || localStorage.tipo == "interno" ||
		localStorage.tipo == "defis" || localStorage.tipo == "fiscalAssessor" ||
		localStorage.nome == "Tatiane Lima" || localStorage.nome == "Sthefany Grilo") {

		return (
			<>
				<iframe title="Report Section" ref={iframeRef}
					width={width}
					height={tempHeight}
					src="https://app.powerbi.com/view?r=eyJrIjoiYzlhM2U5MmUtYzYwYy00ZmU1LWIxMDMtYzRjZjE1MjZiNzdiIiwidCI6IjNjNjE5YTUwLWM2OGMtNGQ1OC1iMmQ3LWY0NDAyNTYwYWYyYyJ9&pageName=ReportSectionec117adeb7a20bd2b579"
					frameborder="0"
					allowFullScreen="true"
				></iframe>
			</>
		)
	} else {
		return <></>
	}
}

export default Report